import { render, staticRenderFns } from "./TableProviders.vue?vue&type=template&id=47ac614a"
import script from "./TableProviders.vue?vue&type=script&lang=js"
export * from "./TableProviders.vue?vue&type=script&lang=js"
import style0 from "./TableProviders.vue?vue&type=style&index=0&id=47ac614a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports